{
  "account.breadcrumb": {
    "translation": "Mon compte"
  },
  "account.hub.documentTitle": {
    "translation": "Mon compte"
  },
  "account.hub.security": {
    "translation": "Sécurité"
  },
  "account.passkeys.breadcrumb": {
    "translation": "Clés d'accès et de sécurité"
  },
  "account.passkeys.documentTitle": {
    "translation": "Clés d'accès et de sécurité"
  },
  "auth-action.enter-code": {
    "translation": "Code de sécurité renforcée"
  },
  "auth-action.forgot-password": {
    "translation": "Mot de passe oublié"
  },
  "auth-action.loading": {
    "translation": "Chargement en cours"
  },
  "auth-action.reset-password": {
    "translation": "Réinitialisation du mot de passe"
  },
  "auth-action.sign-in": {
    "translation": "Connexion"
  },
  "auth-action.sign-out": {
    "translation": "Se déconnecter"
  },
  "auth-provider.authentication-failed": {
    "translation": "Impossible de se connecter"
  },
  "auth-provider.google-authentication-failed": {
    "translation": "La connexion avec google a échoué"
  },
  "auth-provider.passkey-authentication-failed": {
    "translation": "La connexion par clé d'accès a échoué. Vérifiez qu'une passkey est bien enregistrée pour ce compte."
  },
  "auth-provider.password-authentication-failed": {
    "translation": "L'email ou le mot de passe est incorrect"
  },
  "auth.brand-panel.body": {
    "translation": "Donner à chaque commerce les moyens d'une communication digitale efficace et distinctive."
  },
  "auth.brand-panel.headline": {
    "translation": "Amplify what's next"
  },
  "auth.email-sent.back": {
    "translation": "Retour à la page de connexion"
  },
  "auth.email-sent.email-sent": {
    "translation": "Un email a été envoyé à <email></email> avec les instructions pour réinitialiser votre mot de passe 🚀"
  },
  "auth.email-sent.resend": {
    "translation": "Je n'ai pas reçu d'email"
  },
  "auth.email-sent.wrong-email": {
    "translation": "Je me suis trompé d'adresse email"
  },
  "auth.enter-code-form.invalid-code": {
    "translation": "Veuillez saisir un code valide"
  },
  "auth.enter-code-form.label": {
    "translation": "Saisir le code"
  },
  "auth.enter-code-form.submit": {
    "translation": "Se connecter"
  },
  "auth.enter-code-form.trust-device": {
    "translation": "Faire confiance à ce navigateur"
  },
  "auth.enter-code-form.trust-device-tooltip": {
    "translation": "Cochez cette case si vous êtes le seul utilisateur de ce navigateur et qu'il s'agit de votre ordinateur. Nous conserverons cette information et vous n'aurez pas à renseigner de code pendant 30 jours."
  },
  "auth.enter-code.forgot-password": {
    "translation": "Mot de passe oublié / Première connexion"
  },
  "auth.enter-code.no-account": {
    "translation": "Pas encore de compte avec cette adresse ? Rendez-vous sur le lien ci-dessous :"
  },
  "auth.enter-code.not-received": {
    "translation": "Rien reçu ? Nos emails de validation se retrouvent parfois dans les courriers indésirables."
  },
  "auth.enter-code.title": {
    "translation": "Pour sécuriser votre accès, veuillez saisir le code qui vient d'être envoyé sur votre adresse email :"
  },
  "auth.forgot-password-form.email": {
    "translation": "Email"
  },
  "auth.forgot-password-form.email-invalid": {
    "translation": "L'email est invalide"
  },
  "auth.forgot-password-form.email-placeholder": {
    "translation": "Entrez votre email"
  },
  "auth.forgot-password-form.submit": {
    "translation": "Envoyer"
  },
  "auth.forgot-password.back": {
    "translation": "Retour à la page de connexion"
  },
  "auth.forgot-password.forgot-password-message": {
    "translation": "Veuillez renseigner votre email pour recevoir le lien de réinitialisation de mot de passe"
  },
  "auth.layout.header-wrapper.advertising-manager": {
    "translation": "Gestionnaire de publicité"
  },
  "auth.login-form.change-email": {
    "translation": "Modifier"
  },
  "auth.login-form.continue": {
    "translation": "Continuer"
  },
  "auth.login-form.credentials-invalid": {
    "translation": "L'email ou le mot de passe est incorrect"
  },
  "auth.login-form.email": {
    "translation": "Email"
  },
  "auth.login-form.email-invalid": {
    "translation": "Veuillez entrer une adresse email valide"
  },
  "auth.login-form.email-placeholder": {
    "translation": "Entrez votre email"
  },
  "auth.login-form.password": {
    "translation": "Mot de passe"
  },
  "auth.login-form.password-invalid": {
    "translation": "Veuillez entrer votre mot de passe"
  },
  "auth.login-form.password-placeholder": {
    "translation": "Entrez votre mot de passe"
  },
  "auth.login-form.submit": {
    "translation": "Se connecter"
  },
  "auth.login-form.too-many-attempts": {
    "placeholders": {
      "minutes": ["Math.max(1, Math.ceil(outcome.retryAfterSeconds / 60))"]
    },
    "translation": "Trop de tentatives. Réessayez dans {minutes} minutes."
  },
  "auth.login-form.too-many-attempts-soon": {
    "translation": "Trop de tentatives. Réessayez dans quelques instants."
  },
  "auth.login.forgotton-password": {
    "translation": "Mot de passe oublié / Première connexion ?"
  },
  "auth.login.or": {
    "translation": "ou"
  },
  "auth.passkey-enrollment.activate": {
    "translation": "Activer"
  },
  "auth.passkey-enrollment.cancel": {
    "translation": "Annuler"
  },
  "auth.passkey-enrollment.description": {
    "translation": "Utilisez la reconnaissance d'empreinte digitale ou de visage pour vos prochaines connexions en l'activant."
  },
  "auth.passkey-enrollment.error-challenge": {
    "translation": "Réponse serveur invalide pour l'enregistrement de la clé d'accès."
  },
  "auth.passkey-enrollment.error-generic": {
    "translation": "L'enregistrement de la clé d'accès a échoué."
  },
  "auth.passkey-enrollment.error-no-webauthn": {
    "translation": "Votre navigateur ne prend pas en charge les clés d'accès."
  },
  "auth.passkey-enrollment.error-register": {
    "translation": "Impossible d'enregistrer la clé d'accès."
  },
  "auth.passkey-enrollment.error-title": {
    "translation": "Configuration de la clé d'accès impossible"
  },
  "auth.passkey-enrollment.later": {
    "translation": "Plus tard"
  },
  "auth.passkey-enrollment.title": {
    "translation": "Se connecter sans mot de passe"
  },
  "auth.passkey-enrollment.verifying-hint": {
    "translation": "Touchez Touch ID ou regardez Face ID pour confirmer."
  },
  "auth.passkey-enrollment.verifying-title": {
    "translation": "Activation de votre clé d’accès…"
  },
  "auth.password-tooltip.mandatory-rules": {
    "translation": "Votre mot de passe doit avoir :"
  },
  "auth.password-tooltip.mandatory-rules.length": {
    "translation": "au moins 8 caractères"
  },
  "auth.password-tooltip.mandatory-rules.lowercase": {
    "translation": "au moins 1 lettre minuscule"
  },
  "auth.password-tooltip.mandatory-rules.number": {
    "translation": "au moins 1 chiffre"
  },
  "auth.password-tooltip.mandatory-rules.special-character": {
    "translation": "au moins 1 caractère spécial"
  },
  "auth.password-tooltip.mandatory-rules.uppercase": {
    "translation": "au moins 1 lettre majuscule"
  },
  "auth.password-tooltip.recommended-rules": {
    "translation": "Évitez les mots de passe que vous utilisez sur d'autres sites ou que quelqu'un d'autre pourrait aisément deviner."
  },
  "auth.password-tooltip.security": {
    "translation": "Sécurité du mot de passe :"
  },
  "auth.password-tooltip.security.medium": {
    "translation": "moyenne"
  },
  "auth.password-tooltip.security.strong": {
    "translation": "forte"
  },
  "auth.password-tooltip.security.weak": {
    "translation": "faible"
  },
  "auth.pat-sign-in.manual-placeholder": {
    "translation": "Collez un jeton d'accès personnel"
  },
  "auth.pat-sign-in.manual-submit": {
    "translation": "Se connecter"
  },
  "auth.pat-sign-in.no-profiles": {
    "translation": "Aucun jeton trouvé dans ~/.mobsuccess.yml"
  },
  "auth.pat-sign-in.separator": {
    "translation": "ou connectez-vous avec un jeton"
  },
  "auth.query-error-notifier.description": {
    "translation": "Nos équipes sont déjà sur le coup. Essayez de recharger la page pour continuer."
  },
  "auth.query-error-notifier.reload": {
    "translation": "Recharger"
  },
  "auth.query-error-notifier.title": {
    "translation": "Oups, quelque chose n’a pas fonctionné"
  },
  "auth.reset-password.back": {
    "translation": "Retour à la page de connexion"
  },
  "auth.reset-password.confirm-password.label": {
    "translation": "Confirmer le mot de passe"
  },
  "auth.reset-password.confirm-password.placeholder": {
    "translation": "Mot de passe"
  },
  "auth.reset-password.password-validation-error.miss-match": {
    "translation": "Les mots de passe ne correspondent pas"
  },
  "auth.reset-password.password-validation-error.weak": {
    "translation": "Le mot de passe est trop faible, veuillez en choisir un plus fort"
  },
  "auth.reset-password.password.label": {
    "translation": "Mot de passe"
  },
  "auth.reset-password.password.placeholder": {
    "translation": "Mot de passe"
  },
  "auth.reset-password.submit": {
    "translation": "Valider"
  },
  "index.redirecting-loader": {
    "translation": "Redirection en cours…"
  },
  "language-select.error-description": {
    "translation": "Cette langue n'est pas supportée"
  },
  "language-select.error-title": {
    "translation": "Erreur au changement de langue"
  },
  "passkeys-account.add-connection": {
    "translation": "Ajouter une connexion"
  },
  "passkeys-account.add-connection-busy": {
    "translation": "Enregistrement…"
  },
  "passkeys-account.add-connection-busy-hint": {
    "translation": "Répondez à la demande dans votre navigateur ou sur votre appareil (empreinte, visage ou clé de sécurité)."
  },
  "passkeys-account.created": {
    "translation": "Création :"
  },
  "passkeys-account.default-name": {
    "translation": "Passkey"
  },
  "passkeys-account.delete": {
    "translation": "Supprimer"
  },
  "passkeys-account.delete-cancel": {
    "translation": "Annuler"
  },
  "passkeys-account.delete-confirm": {
    "translation": "Supprimer cette clé d’accès ?"
  },
  "passkeys-account.delete-passkey": {
    "translation": "Supprimer"
  },
  "passkeys-account.empty": {
    "translation": "Aucune clé d’accès enregistrée."
  },
  "passkeys-account.error.generic": {
    "translation": "Une erreur est survenue."
  },
  "passkeys-account.error.invalid-challenge": {
    "translation": "Réponse serveur invalide (challenge manquant)."
  },
  "passkeys-account.error.no-webauthn": {
    "translation": "Votre navigateur ne prend pas en charge les passkeys."
  },
  "passkeys-account.error.register-failed": {
    "translation": "L’enregistrement de la clé a échoué."
  },
  "passkeys-account.hub.title": {
    "translation": "Mon compte"
  },
  "passkeys-account.last-used-label": {
    "translation": "Dernière utilisation :"
  },
  "passkeys-account.last-used.just-now": {
    "translation": "À l'instant"
  },
  "passkeys-account.last-used.minutes-ago": {
    "placeholders": {
      "minutes": ["diffMin"]
    },
    "translation": "Il y a {minutes} min"
  },
  "passkeys-account.loading": {
    "translation": "Chargement…"
  },
  "passkeys-account.page.title": {
    "translation": "Clés d’accès et de sécurité"
  },
  "passkeys-account.quick-login.intro": {
    "translation": "Gérez votre trousseau de clés d’accès pour vous connecter sans mot de passe."
  },
  "passkeys-account.quick-login.subtitle": {
    "translation": "Gérer vos connexions sans mot de passe"
  },
  "passkeys-account.quick-login.title": {
    "translation": "Clés d’accès et de sécurité"
  },
  "passkeys-account.registered-connections": {
    "translation": "Connexions enregistrées"
  },
  "root.pending-loader": {
    "translation": "Chargement…"
  },
  "src.public.auth.forgot-password-error.button-text": {
    "translation": "Nous contacter"
  },
  "src.public.auth.forgot-password-error.description": {
    "translation": "Nous n'avons pas pu vous envoyer le lien de réinitialisation de mot de passe. Veuillez réessayer plus tard."
  },
  "src.public.auth.forgot-password-error.description-npai": {
    "translation": "Une erreur concernant votre compte n'a pas pu être résolue. Veuillez contacter le support en leur fournissant une adresse e-mail différente."
  },
  "src.public.auth.forgot-password-error.title": {
    "translation": "Une erreur est survenue"
  },
  "src.public.auth.reset-password-error.description": {
    "translation": "Nous n'avons pas pu réinitialiser votre mot de passe. Veuillez demander un nouveau lien de réinitialisation de mot de passe."
  },
  "src.public.auth.reset-password-error.title": {
    "translation": "Une erreur est survenue"
  },
  "src.public.auth.reset-password-success.description": {
    "translation": "Vous pouvez maintenant vous connecter avec votre nouveau mot de passe !"
  },
  "src.public.auth.reset-password-success.title": {
    "translation": "Votre mot de passe a été réinitialisé avec succès 🚀"
  },
  "src.public.use-send-2fa-auth.error.title": {
    "translation": "Une erreur est survenue"
  },
  "theme-switch.to-dark": {
    "translation": "Passer au thème sombre"
  },
  "theme-switch.to-light": {
    "translation": "Passer au thème clair"
  }
}
